type LabeledOption = {
  label: string;
};

const leaguePriority = [
  "Premier League",
  "Championship",
  "League One",
  "League Two",
];

const leaguePriorityIndex = new Map(
  leaguePriority.map((league, index) => [league.toLowerCase(), index]),
);

export const sortByLabel = <T extends LabeledOption>(options: T[]): T[] => {
  return [...options].sort((a, b) =>
    a.label.localeCompare(b.label, "en", { sensitivity: "base" }),
  );
};

export const sortLeagueOptions = <T extends LabeledOption>(
  options: T[],
): T[] => {
  return [...options].sort((a, b) => {
    const aLabel = a.label ?? "";
    const bLabel = b.label ?? "";
    const aKey = aLabel.toLowerCase();
    const bKey = bLabel.toLowerCase();

    const aPriority = leaguePriorityIndex.has(aKey)
      ? leaguePriorityIndex.get(aKey)!
      : Number.POSITIVE_INFINITY;
    const bPriority = leaguePriorityIndex.has(bKey)
      ? leaguePriorityIndex.get(bKey)!
      : Number.POSITIVE_INFINITY;

    if (aPriority !== bPriority) {
      return aPriority - bPriority;
    }

    return aLabel.localeCompare(bLabel, "en", { sensitivity: "base" });
  });
};
